import { createSelector } from 'reselect'
import { EmptyArray } from 'lib/array/arrayUtils'
import getLoyaltyLoungePassItemViews from 'checkout/selectors/view/itemViews/getLoyaltyLoungePassItemViews'
import { getPromoKeyForLoyaltyItem } from 'lib/promo/promoMappers'
import { generateLoyaltyPointsCalculatorExperienceOptions } from 'loyalty/lib/pointsCalculation/calculatorOptionsGenerators'

const getCheckoutLoungePassPointsCalculationRequest = createSelector(
  (state: App.State) => getLoyaltyLoungePassItemViews(state),
  (state: App.State) => state.checkout.promo?.loyaltyPointsBonusResultV1,
  (loungePassViews, loyaltyPointsBonusResultV1): Array<App.LoyaltyPointsEarnCalculationRequest> => {
    if (!loungePassViews.hasRequiredData) return EmptyArray

    return loungePassViews.data.map((itemView): App.LoyaltyPointsEarnCalculationRequest => {
      const itemId = itemView.item.itemId
      const request = generateLoyaltyPointsCalculatorExperienceOptions(itemView.experience, {
        offerId: itemView.item.experienceId,
        price: itemView.totals.price,
        memberPrice: itemView.totals.memberPrice,
        promoKey: getPromoKeyForLoyaltyItem(loyaltyPointsBonusResultV1, { filter: { itemId } }),
      })!

      const checkoutRequest = {
        ...request,
        // Local checkout correlation only; omitted from the API payload and points key.
        itemId,
      }

      return checkoutRequest
    })
  },
)

export default getCheckoutLoungePassPointsCalculationRequest
